import clsx from "clsx";

import useModals from "../hooks/useModals";
import useJStyles from "$hooks/useJStyles";
import { Loader } from "$components/Layout/Loader";
import JTooltip from "$components/JTooltip/JTooltip";
import { EDB_IS_DISABLED_MSG } from "$containers/EDB/constants";
import { useStyles } from "../styles/ProfileEDB.styles";
import AddingMaterial from "../components/AddingMaterial";
import { Table, Button as LocalButton } from "$components";
import useProfileEDBTable from "../hooks/useProfileEDBTable";
import { useProfileEDBContext } from "$containers/EDB/ProfileEDB/context/ProfileEDBContext";
import IntegratedOrdersRecapTable from "$containers/EDB/form/components/IntegratedOrders/IntegratedOrdersRecapTable";
import useAuth from "$hooks/useAuth";

export default function MaterialNeedTab() {
  const classes = useStyles();
  const { jclasses } = useJStyles();
  const { isClient } = useAuth();

  const { updateProducts } = useModals();
  const { tableHeader, renderProduct } = useProfileEDBTable();

  const {
    edb,
    opList,
    isDisabled,
    isAddingMaterial,
    integratedOrders,
    isLoadingIntegratedOrders,

    setIsAddingMaterial,
    setIntegratedOrders,
    onDeleteIntegratedProduct,
  } = useProfileEDBContext();

  if (isAddingMaterial) {
    return <AddingMaterial />;
  }

  return (
    <div className={jclasses.scrollTable}>
      {edb?.products.some((p) => !p.receptionReferenceId) && (
        <Table
          className={clsx(classes.products, classes.table)}
          rowsPerPage={1000}
          thead={tableHeader}
          bodyData={renderProduct()}
          noPointer
          noHover
        />
      )}
      {isLoadingIntegratedOrders ? (
        <Loader />
      ) : (
        <IntegratedOrdersRecapTable
          className={clsx(classes.orderRecapTable, classes.table)}
          integratedOrders={integratedOrders}
          onDeleteIntegratedProduct={onDeleteIntegratedProduct}
          setIntegratedOrders={setIntegratedOrders}
          updateProducts={updateProducts}
          edbProducts={edb?.products}
          opList={opList}
          isEdbDisabled={isDisabled}
        />
      )}
      <div className={classes.addMaterialBtn}>
        <JTooltip title={isDisabled && !isClient() && EDB_IS_DISABLED_MSG}>
          <LocalButton
            onClick={() => setIsAddingMaterial(true)}
            disabled={isDisabled}
          >
            Ajouter du matériel
          </LocalButton>
        </JTooltip>
      </div>
    </div>
  );
}
